import React, { lazy } from "react";
import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import di from "@di";
import Header from "./header/Header";
const Home = lazy(() => import("./Home/home"));
import MobTopNav from "./header/MobileTopNav";
import { symbols } from "../constant/symbols";
import { Routes, Route, useNavigate } from "react-router-dom";
const Markets = lazy(() => import("./features/Markets/markets"));
import { fetchAccountDetails } from "@frameworks/web/redux/reducers/Reports/accountDetailsThunk";
import { AuthToSellJourney } from "./features/TOC/Equity/EqTOCFunctionality";
// import EventCalendarRouting from "./features/ClientEventCalendar/EventCalendarRouting";
import DeviceContext from "@frameworks/web/components/generic/customHooks/indentifyDevice";
// import OfferingsRouting from "./features/Offerings/OfferingsRouting";
// import LiveNewsRouting from "./features/LiveNews/LiveNewsRouting";
import TicketPortalRouting from "./features/TicketPortal/TicketPortalRouting";
import "../assets/scss/variables/fontFamily.scss";
import "../stylesheets/global/global.scss";
import "../assets/icons/edel_icons/style.scss";
import "../stylesheets/components/error_msg.scss";
import LeadGenRouting from "@frameworks/web/components/features/LeadGeneration/LeadGenerationRouting";
const Index = () => {
    const dispatch = useDispatch();
    const device = DeviceContext();
    const [isMainPage, setIsMainPage] = useState(null);
    const navigate = useNavigate();
    useEffect(() => {
        setIsMainPage(true);
    });
    React.useEffect(() => {
        getstream();
        dispatch(fetchAccountDetails());
        authToSell();
        let getServerKey = localStorage.getItem("serverKey");
        // if (!getServerKey) {
        //   di.home.getServerKey();
        // }
    }, []);
    const getstream = async () => {
        di.header.getStreamData(true);
        await di.header.getMarketData([symbols[0].symbol, symbols[1].symbol]);
        // await di.header.getMarketData([symbols[0].symbol, symbols[1].symbol]);
    };
    const authToSell = () => {
        let Authsymbol = AuthToSellJourney().PostCDSLRedirection();
        if (Authsymbol) {
            localStorage.removeItem("AuthToSellSymbol");
            (device === null || device === void 0 ? void 0 : device.isDesktop)
                ? navigate("/markets/equity", {
                    state: { Authsymbol: Authsymbol },
                })
                : navigate("/buy-stock", {
                    state: { Authsymbol: Authsymbol },
                });
        }
    };
    useEffect(() => {
        setIsMainPage(true);
    });
    useEffect(() => {
        getstream();
        dispatch(fetchAccountDetails());
        authToSell();
        return () => {
            di.header.getStreamData(false);
        };
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: device && (device === null || device === void 0 ? void 0 : device.isDesktop) ? "wrap" : "mob-page" },
            device && (device === null || device === void 0 ? void 0 : device.isDesktop) ? React.createElement(Header, null) : React.createElement(MobTopNav, null),
            React.createElement(Routes, null,
                React.createElement(Route, { index: true, element: React.createElement("div", null, "Page not found!") })),
            React.createElement(TicketPortalRouting, null),
            React.createElement(LeadGenRouting, null))));
};
export default Index;
